import React from 'react';
import TTLProxy from "../../../../common/TTLAsyncProxy";
import {MiscEndpoints, USSDEndpoints} from "../../../../common/ProxyEndpoints";
import moment from 'moment';
import {Button, Col, Modal, ModalBody, ModalHeader, Row, Table, UncontrolledButtonDropdown} from 'reactstrap';
import Utils from "../../../../common/Utils";
import Spinner from 'react-md-spinner';
import './USSDServices.css';
import Confirm from "../../../../components/Confirm/Confirm";
import DialogCollapseSection from "../../../../components/DialogCollapseSection";
import FormRenderer from "../../../../common/FormRenderer/FormRenderer";
import ProgressBar from 'react-md-progress-bar';
import MDProgress from 'react-md-progress-bar';
import HTML from '../../../../common/HtmlHelpers';
import ErrorFrame from "../../../../components/ErrorFrame/ErrorFrame";
import DocumentTitle from 'react-document-title';
import AppVariables from "../../../../common/AppVariables";
import PropTypes from 'prop-types';
import CurrencyLabel from "../../../../components/CurrencyLabel/CurrencyLabel";
import Badge from "reactstrap/es/Badge";
import _ from 'lodash';
import ButtonGroup from "reactstrap/es/ButtonGroup";
import TimeAgo from "../../../../common/TimeAgo";
import DropdownMenu from "reactstrap/es/DropdownMenu";
import DropdownToggle from "reactstrap/es/DropdownToggle";
import DropdownItem from "reactstrap/es/DropdownItem";
import EditBindingDialog from "./EditBindingDialog";
import CreateBindingDialog from "./CreateBindingDialog";
import PermissionRender from "../../../../components/PermissionRender/PermissionRender";
import {Permissions} from "../../../../common/Constants";
import RegionsManagementDialog from "./RegionsManagementDialog";
import RegisterRegionDialog from "./RegisterRegionDialog";

const DefaultProduct = "#default";

class ServiceView extends React.Component{

    static propTypes = {
        service: PropTypes.object,
        classes: PropTypes.string,
        onEdit: PropTypes.func,
        onChangeState: PropTypes.func,
        onRemoveBinding: PropTypes.func,
        onBindingCreated: PropTypes.func,
        onBindingEdited: PropTypes.func,
        busy: PropTypes.bool,
        settings: PropTypes.array
    };

    constructor(props){
        super(props);
        this.state = {
            isBusy: false,
            deleteItem: null,
            modifyItem: null
        };
        this.proxy = TTLProxy.getInstance();
    }


    getPriceFactor(){

        const s = this.props.settings.find(x => x.name = "priceFactor");
        if(s !== undefined){
            return Number(s.value);
        }

        return 1;
    }

    handleChangeState(enable){

        if(this.props.onChangeState)
            return this.props.onChangeState(enable);

    }

    handleDeletePriceBinding(){

        const { deleteItem } = this.state;
        if(this.props.onRemoveBinding)
            this.props.onRemoveBinding(deleteItem);

    }


    render(){

        const props = this.props;
        const service = props.service;
        const pricingGroups = _.uniqBy(service.pricing.map(x => x.pricing_group),'id');

        const findLastUpdated = (service) => {

            let serviceLastUpdate = moment(service.last_updated);
            if(service.pricing.length === 0){
                return serviceLastUpdate;
            }

            let max = moment(service.pricing[0].last_updated);
            for(let i = 1 , len = service.pricing.length; i < len ; i++){
                let p = moment(service.pricing[i].last_updated);
                if(p.isAfter(max)){
                    max = p;
                }
            }

            return serviceLastUpdate.isAfter(max) ? serviceLastUpdate : max;
        };

        const _lastUpdated = findLastUpdated(service);

        return (<div className="col-sm-6 col-md-4">

                <div className={`card ${service.enable ? 'card-black' : 'card-disabled'}"`} style={{
                    boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
                }}>

                    <div className={`card-header ${service.enable ? 'card-header-black' : 'card-header-disabled' }`}>
                        <b>{service.enable ? <Badge pill color={"green"} style={{color: "white"}}><i className="fa fa-check-circle"/> Enabled</Badge> : <Badge pill color="danger"><i className="fa fa-trash"/> Disabled</Badge> }</b>
                        {!_lastUpdated.isSame(service.date_created) && <span className="float-right">Edited: <TimeAgo style={{display: "inline"}} id={`service-${service.id}-tip`} date={_lastUpdated}/></span>}
                    </div>

                    <div className="card-block">

                        <div className="text-center" style={{padding: '10px'}}>

                            <h3>
                                <span style={{fontSize: '20px'}}>
                                <b>{service.name}</b>
                                </span>
                            </h3>
                            <CurrencyLabel value={service.unit_cost}/>

                        </div>

                        <hr/>

                        <DialogCollapseSection title={<h6>Details</h6>} initiallyOpen={false}>

                            <Row>

                                <Col md={6}>

                                    <b>Base Price</b>
                                    <p><CurrencyLabel value={service.unit_cost}/></p>

                                    <b>Service Name</b>
                                    <p>{service.name}</p>

                                </Col>

                                <Col md={6}>

                                    <b>Scaled Price</b>
                                    <p><CurrencyLabel value={service.unit_cost * this.getPriceFactor()}/></p>

                                    <b>Unit name</b>
                                    <p>{service.unit_name}</p>

                                </Col>

                            </Row>

                            <b>Description</b>
                            <p>{service.description}</p>
                        </DialogCollapseSection>

                        <DialogCollapseSection title={<h6>Pricing</h6>} initiallyOpen={false}>
                            {pricingGroups.map((group,key) => <div key={key} className="mb-3">

                                <div className="clearfix">
                                    <h6 className="font-weight-bold pull-left"><i className="fa fa-globe"/> {group.name}</h6>
                                    <div className="pull-right">

                                        <PermissionRender required={[ Permissions.USSDServices.Update ]} superUser>
                                            <span style={{color: "#32a301" , cursor: "pointer"}} className="mr-2" onClick={() => {
                                                this._createBindingDlg.show(group,false);
                                            }}><i className="fa fa-plus"/></span>
                                        </PermissionRender>

                                    </div>
                                </div>

                                <Table hover striped responsive size={"sm"}>

                                    <thead>

                                    <tr>
                                        <td><i className="fa fa-book"/> Product</td>
                                        <td><i className="fa fa-money"/> Cost</td>
                                        <td/>
                                    </tr>

                                    </thead>

                                    <tbody>
                                    {service.pricing.filter(x => x.pricing_group.id === group.id).map((x,index) => <tr key={index}>
                                        <td>{x.product === DefaultProduct ? <Badge pill color={"primary"}>Default</Badge> : x.product}</td>
                                        <td><CurrencyLabel value={x.cost}/></td>
                                        <td>

                                            <PermissionRender required={[ Permissions.USSDServices.Update ]} superUser>

                                                <span style={{ cursor: "pointer" }} title={"Click to edit"} onClick={() => {
                                                    this._editBindingDlg.show(x);
                                                }}><i className="fa fa-edit"/></span>

                                                <span style={{ cursor: "pointer" , marginLeft: 4 }} className="ml-1" title="Click to remove definition" onClick={() => {

                                                    this.setState({
                                                        deleteItem: x
                                                    }, () => this._deletePricingRule.show());

                                                } }><i className="fa fa-trash"/></span>

                                            </PermissionRender>

                                        </td>
                                    </tr>)}
                                    </tbody>

                                </Table>

                            </div>)}

                            <PermissionRender required={[ Permissions.USSDServices.Update ]} superUser>
                                <div style={{width: "100%"}} className="text-center">
                                    <Button color={"link"} onClick={() => {
                                        this._createBindingDlg.show(null,true);
                                    }}><i className="fa fa-plus"/> Add Category</Button>
                                </div>
                            </PermissionRender>

                        </DialogCollapseSection>

                    </div>

                    <div className="card-footer">

                        <PermissionRender required={[ Permissions.USSDServices.Update ]} superUser>

                            <div className="clearfix">

                                <div className="pull-left">
                                    <Button color="link"  size={"sm"} style={{color: 'white'}} onClick={this.props.onEdit}><i className="fa fa-edit"></i> Edit</Button>
                                </div>

                                <div className="pull-right">
                                    {service.enable ? <Button size={"sm"} color="danger" onClick={() => this._disableServiceDlg.show() }><i className="fa fa-close"/> Disable</Button>  :
                                        <Button color="success" onClick={() => this._enableServiceDlg.show()}><i className="fa fa-check-circle-o"/> Enable</Button> }
                                </div>

                            </div>

                        </PermissionRender>

                        <EditBindingDialog ref={r => this._editBindingDlg = r} onEdit={this.props.onBindingEdited}/>

                        <CreateBindingDialog service={service} ref={r => this._createBindingDlg = r}  onCreate={this.props.onBindingCreated}/>


                        <Confirm title="Disable Service?" ref={(dlg) => this._disableServiceDlg = dlg }
                                 body="Are you sure you want to disable the selected service?"
                                 confirmText="Disable"
                                 confirmBtnColor="danger"
                                 onConfirm={this.handleChangeState.bind(this,false)}/>


                        <Confirm title="Enable Service?" ref={(dlg) => this._enableServiceDlg = dlg }
                                 body="Are you sure you want to enable the selected service?"
                                 confirmText="Enable"
                                 confirmBtnColor="success"
                                 onConfirm={this.handleChangeState.bind(this,true)}/>

                        <Confirm title="Delete Pricing Definition?" ref={(dlg) => this._deletePricingRule = dlg }
                                 body="Are you sure you want to delete the selected pricing definition?"
                                 confirmText="Delete"
                                 confirmBtnColor="danger"
                                 onConfirm={this.handleDeletePriceBinding.bind(this)}/>

                    </div>
                </div>
            </div>);
    }

}

const DialogTypes = {
    Create: 0,
    Edit: 1
};


class USSDServices extends React.Component{

    constructor(props){
        super(props);

        this.state = {
            services: [],
            settings: [],
            dialogOpen: false,
            dialogType: null,
            editItem: null,
            isBusy: false,
            isLoaded: false,
            isCreating: false,
            faulted: false,
            errorMessage: null
        };

        this.proxy = TTLProxy.getInstance();

        this.dialogToggle = this.toggleDialog.bind(this);

        this.formInputs = [
            { name: 'name' , title: "Name", type: 'text' , hint: 'Enter service name here...' , required: true },
            { name: 'unit_cost' , title: "Service Base Cost" , type: 'number' , hint : 'Enter base cost' , comment: `The standard base price for the service in ${AppVariables.CurrencyCode}` , required: true , defaultValue : 1 },
            { name: 'unit_name' , title:  "Unit Name", type: 'select',
                items: [
                    { text: "Hectare" , value: "Hectare" },
                    { text: "Bag", value: "Bag" },
                    { text: "Day" , value: "Day" },
                    { text: "Week" , value: "Week" },
                    { text: "Month" , value: "Month" },
                ],
                required: true
            },
            { name: 'description', title: "Description (Optional)" , type: 'textarea' , hint: 'Enter brief description of service input here...' , rows: 3 },
        ];
    }

    fetchServices(){

        return this.proxy.processRequest( USSDEndpoints.getUSSDServices().url , {
            include: ["pricing"]
        } ).then(response => {
            return response.getPayload();
        });
    }

    fetchSettings(){
        return this.proxy.processRequest( MiscEndpoints.getSettings() ).then(response =>{
            return response.getPayload();
        });
    }

    loadState(){

        this.setState({
            isBusy: true,
            faulted: false,
            errorMessage: null
        });

        return Promise.all( [ this.fetchServices() , this.fetchSettings() ] ).then(values =>{

            this.setState({
                services:values[0],
                settings: values[1],
                isLoaded: true,
                isBusy: false,
                faulted: false
            });

        }).catch(err => {

            this.setState({
                isBusy: false,
                faulted: true,
                errorMessage: Utils.getResponseError(err)
            });

            return Promise.reject(err);
        });

    }

    componentDidMount(){
        return  this.loadState();
    }

    showDialog(dialog){

        this.setState({
            dialogOpen: true,
            dialogType: dialog
        });
    }

    onAddNewService(){

        if(!this.state.isBusy) {
            this.showDialog(DialogTypes.Create);
        }

    }

    toggleDialog(){

        this.setState({
            dialogOpen: !this.state.dialogOpen,
        });

    }

    onShowDialog(){

        const dlg = this.state.dialogType;
        const service = this.state.editItem;
        if(dlg == DialogTypes.Edit && service !== null){
            this._createEditFormRenderer.bindItem(service);
        }

    }

    onCreateService(payload){

        const proxy = this.proxy;
        const formData = this._createEditFormRenderer.getFormData();

        return proxy.processRequest(USSDEndpoints.createUSSDService(formData)).then(response => {

            //
            HTML.toastMessage("Service added successfully!");

            //  close dialog
            return true;

        }).catch(err => {

            this._createEditFormRenderer.updateException(err);

            return false;
        });
    }


    async handleDeletePriceBinding(service,binding){

        try {

            const res =  await this.proxy.processRequest(USSDEndpoints.removeServiceBinding(binding.id));

            if(res.ok){

                //
                HTML.toastSuccess('Price definition removed successfully');

                //  refresh services
                await this.onServiceBindingUpdated(service);

                //  hide service
                return true;
            }

        }
        catch (e) {
            HTML.toastError(Utils.getResponseError(e));
        }

    }


    async changeServiceState(service,enable){

        const proxy = this.proxy;

        try {

            const res = await proxy.processRequest(USSDEndpoints.updateUSSDService(service.id, {
                enable
            }));

            if(res.ok){
                HTML.toastMessage(`Service ${enable ? 'enabled' : 'disabled'} successfully`);
                this.refresh();
                return true;
            }


        }
        catch (e) {
            HTML.toastWarning(Utils.getResponseError(e));
        }

        return  false;
    }

    onEditService(payload,affected){

        const proxy = this.proxy;
        const formData = this._createEditFormRenderer.getFormData();

        return proxy.processRequest(USSDEndpoints.updateUSSDService(this.state.editItem.id, formData)).then(response =>{

            HTML.toastMessage("Service updated successfully!");

            return true;

        }).catch(err =>{

            this._createEditFormRenderer.updateException(err);

            return false;
        });

    }

    renderButtonContent(){

        switch (this.state.dialogType){
            case DialogTypes.Edit:
                return <span><i className="fa fa-edit"></i> Save Changes</span>;
            case DialogTypes.Create:
                return <span><i className="fa fa-plus"></i> Add Service</span>;
        }

    }

    renderModals(){

        const me = this;
        let dlg = this.state.dialogType;
        const isBusy = this.state.isCreating;
        const isLoaded = this.state.isLoaded;

        switch (dlg){
            case DialogTypes.Edit:
            case DialogTypes.Create:
                return <Modal toggle={this.dialogToggle} isOpen={this.state.dialogOpen} onExit={() => me.setState({ editItem: null })} onOpened={this.onShowDialog.bind(this)}>
                    <ModalHeader toggle={this.dialogToggle}>{dlg == DialogTypes.Create ?  "Add New Service" : "Edit Service"}</ModalHeader>

                    <ModalBody>

                        <FormRenderer ref={input => this._createEditFormRenderer = input}
                                      onSubmit={(formData) => {

                                          this.setState({
                                              isCreating: true
                                          });

                                          let promise;
                                          switch (me.state.dialogType){
                                              case DialogTypes.Create:
                                                  promise = me.onCreateService(formData);
                                                  break;
                                              case DialogTypes.Edit:
                                                  promise = me.onEditService(formData,Utils.getDifference(me.state.editItem,formData));
                                                  break;
                                          }

                                          if(promise)
                                              promise.then(response => {

                                                  //  clear busy state
                                                  me.setState({
                                                      isCreating: false
                                                  });

                                                  if(response){

                                                      return me.refresh().then(() =>{
                                                          me.toggleDialog();
                                                      });

                                                  }

                                              });

                                      }}
                                      inputs={this.formInputs}>
                            <hr/>

                            <div style={{width: '100%'}}>
                                <Button block className="btn btn-green">{this.renderButtonContent()}</Button>
                                {isBusy && !isLoaded && <ProgressBar show={true}/>}

                            </div>
                        </FormRenderer>
                    </ModalBody>

                </Modal>;
        }

    }

    refresh(){

        //  just call load state
        return this.loadState();

    }

    deleteService(service){

        const proxy = this.proxy;
        return proxy.processRequest(USSDEndpoints.deleteUSSDService(service.id)).then(response =>{

            HTML.toastMessage('Service was deleted successfully');

            //  refresh view
            this.refresh();

            //  close dialog
            return true;

        }).catch(err => {

            HTML.toastError(Utils.getResponseError(err));

            //  leave dialog open
            return false;
        });

    }

    async onServiceBindingUpdated(service){

        try {

            const { services } = this.state;

            //  query and update service
            const res = await this.proxy.processRequest(USSDEndpoints.getUSSDService(service.id).url, {
                include: ["pricing"]
            });

            //
            const svcIndex = services.findIndex(x => x.id === service.id);

            if(svcIndex >= 0){

                services[svcIndex] = res.getPayload();

                this.setState({
                    services: services
                });

            }

        }
        catch (e) {
            HTML.toastError(Utils.getResponseError(e));
        }

    }

    render(){

        const services = this.state.services;
        const settings = this.state.settings;
        const isBusy = this.state.isBusy;
        const isLoaded = this.state.isLoaded;
        let content;

        if(!this.state.faulted){
            content = (<div>
                {services.length > 0 && <div className="row">
                    {services.map((svc,i) => <ServiceView key={i}
                                                          service={svc}
                                                          settings={settings}
                                                          onRemoveBinding={this.handleDeletePriceBinding.bind(this,svc)}
                                                          onBindingCreated={() => this.onServiceBindingUpdated(svc)}
                                                          onBindingEdited={() => this.onServiceBindingUpdated(svc)}
                                                          onChangeState={async (enable) => await this.changeServiceState(svc,enable)}
                                                          onEdit={() => {

                                                              this.setState({
                                                                  editItem: svc
                                                              },() => {

                                                                  this.setState({
                                                                      dialogOpen: true,
                                                                      dialogType: DialogTypes.Edit,
                                                                  });

                                                              });

                                                          }}
                                                          onDelete={this.deleteService.bind(this,svc)}
                    />)}
                </div>}

                {isBusy && !this.state.dialogOpen && <div className="text-center">
                    <Spinner size={50} />
                    <p style={{marginTop: '20px'}}>Loading services. Please hold on...</p>
                </div>}
            </div>);
        }
        else {
            content = <ErrorFrame  message={this.state.errorMessage} allowRetry={true} retryLabel="Reload services" onRetry={() => this.loadState()}/>
        }

        return (<DocumentTitle title={"USSD Services"}>
            <div className="container-fluid">

                <div className="content-frame" style={{marginBottom: 4}}>
                    <div className="clearfix">
                        <div className="pull-left">
                            <h4>USSD Services</h4>
                        </div>
                        <div className="pull-right">
                            <ButtonGroup>
                                <Button color={"secondary"} onClick={() => this.loadState() }><i className="fa fa-refresh"></i> Refresh</Button>
                                <PermissionRender required={[ Permissions.USSDServices.Create ]} superUser>
                                    <Button className="btn-green" onClick={this.onAddNewService.bind(this)}><i className="fa fa-plus"></i> Add New Service</Button>
                                </PermissionRender>
                            </ButtonGroup>

                            <PermissionRender required={[ Permissions.USSDServices.Update ]} superUser>

                                <UncontrolledButtonDropdown>

                                    <DropdownToggle caret><i className="fa fa-gears"/></DropdownToggle>

                                    <DropdownMenu right style={{ left: 'inherit' }}>
                                        <DropdownItem onClick={() => this._managePricingGroupsDlg.show()}><i className="fa fa-globe"/> Manage Segments</DropdownItem>
                                        <DropdownItem onClick={() => this._createPricingGroupDlg.show()}><i className="fa fa-plus"/> Add New Segment</DropdownItem>
                                    </DropdownMenu>

                                </UncontrolledButtonDropdown>

                            </PermissionRender>

                        </div>
                    </div>
                </div>
                {isBusy && isLoaded && <MDProgress show={true} overlay={true}/>}
                <hr/>

                {content}
                {this.renderModals()}

                <RegionsManagementDialog ref={r => this._managePricingGroupsDlg = r}/>
                <RegisterRegionDialog ref={r => this._createPricingGroupDlg = r}/>

            </div>
        </DocumentTitle>);

    }
}

export default USSDServices;



// WEBPACK FOOTER //
// ./src/views/Extras/Services/USSDServices/USSDServices.js